import { Component, input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { provideIcons } from '@ng-icons/core';
import { lucideChevronRight, lucideSave, lucideX } from '@ng-icons/lucide';
import { HlmTabsImports } from '@spartan-ng/helm/tabs';

import { Référentiel } from '../../administration/gestion-référentiels/models/référentiel.model';
import { Cartographie } from '../../cartographie/models/cartographie.model';
import { EtapeDetailContenuComponent } from './etape-detail-contenu/etape-detail-contenu.component';
import { FinParcoursDetailContenuComponent } from './fin-parcours-detail-contenu/fin-parcours-detail-contenu.component';
import { GroupeEtapesDetailContenuComponent } from './groupe-etapes-detail-contenu/groupe-etapes-detail-contenu.component';
import { JalonDetailContenuComponent } from './jalon-detail-contenu/jalon-detail-contenu.component';
import { ModuleDetailContenuComponent } from './module-detail-contenu/module-detail-contenu.component';

export type TYPE_ÉLÉMENT =
  | 'jalon'
  | 'étape'
  | 'groupe-étapes-à-la-carte'
  | 'module'
  | 'fin-parcours'
  | 'canvas'
  | 'connecteur'
  | null;

@Component({
  selector: 'app-parcours-detail',
  imports: [
    RouterModule,
    HlmTabsImports,
    ModuleDetailContenuComponent,
    EtapeDetailContenuComponent,
    JalonDetailContenuComponent,
    FinParcoursDetailContenuComponent,
    GroupeEtapesDetailContenuComponent,
  ],
  providers: [provideIcons({ lucideX, lucideSave, lucideChevronRight })],
  templateUrl: './parcours-detail.component.html',
})
export class ParcoursDetailComponent {
  readonly cartographie = input.required<Cartographie>();
  readonly referentiel = input.required<Référentiel>();
  readonly peutModifier = input.required<boolean>();

  type = input<TYPE_ÉLÉMENT | null>(null);
  showErrors = input<boolean>();
}
